import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/apiService";


export const GetOneJobOpportunitiesDuringProjectData = createAsyncThunk(
  "OneJobOpportunitiesDuringProjectData/GetOneJobOpportunitiesDuringProjectData",
  async (pR_JobOpportunitiesDuringProjectId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/JobOpportunitiesDuringProject/GetPR_JobOpportunitiesDuringProjectData",
        {
          pR_JobOpportunitiesDuringProjectId:
            pR_JobOpportunitiesDuringProjectId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteJobOpportunitiesDuringProjectData = createAsyncThunk(
  "DeleteJobOpportunitiesDuringProjectData/DeleteJobOpportunitiesDuringProjectData",
  async (pR_JobOpportunitiesDuringProjectId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/JobOpportunitiesDuringProject/DeletePR_JobOpportunitiesDuringProjectData",
        {
          pR_JobOpportunitiesDuringProjectId:
            pR_JobOpportunitiesDuringProjectId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const GetListJobOpportunitiesDuringProjectData = createAsyncThunk(
  "GetListJobOpportunitiesDuringProjectData/GetListJobOpportunitiesDuringProjectData",
  async (pR_ReportsStagesGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/JobOpportunitiesDuringProject/GetPR_JobOpportunitiesDuringProjectListData",
        {
          pR_ReportsStagesGuid: pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const UpdateJobOpportunitiesDuringProjectData = createAsyncThunk(
  "UpdateJobOpportunitiesDuringProjectData/UpdateJobOpportunitiesDuringProjectData",
  async (JobOpportunitiesDuringProject, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/JobOpportunitiesDuringProject/UpdatePR_JobOpportunitiesDuringProjectData",
        {
          pR_JobOpportunitiesDuringProjectId:
            JobOpportunitiesDuringProject.pR_JobOpportunitiesDuringProjectId,
          gender: JobOpportunitiesDuringProject.gender,
          natureOfOpportunity:
            JobOpportunitiesDuringProject.natureOfOpportunity,
          pR_TypeOfJobOpportunityId:
            JobOpportunitiesDuringProject.pR_TypeOfJobOpportunityId,
          pR_ReportsStagesGuid:
            JobOpportunitiesDuringProject.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddJobOpportunitiesDuringProjectData = createAsyncThunk(
  "AddJobOpportunitiesDuringProjectData/AddJobOpportunitiesDuringProjectData",
  async (JobOpportunitiesDuringProject, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/JobOpportunitiesDuringProject/AddPR_JobOpportunitiesDuringProjectData",
        {
          gender: JobOpportunitiesDuringProject.gender,
          natureOfOpportunity:
            JobOpportunitiesDuringProject.natureOfOpportunity,
          pR_TypeOfJobOpportunityId:
            JobOpportunitiesDuringProject.pR_TypeOfJobOpportunityId,
          pR_ReportsStagesGuid:
            JobOpportunitiesDuringProject.pR_ReportsStagesGuid,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "addJobOpportun");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ValidateJobOpportunitiesDuringProject = createAsyncThunk(
  "JobOpportunitiesDuringProject/ValidateJobOpportunitiesDuringProject",
  async (JobOpportunitiesDuringProject, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/JobOpportunitiesDuringProject/ValidatePR_JobOpportunitiesDuringProjectData",
        {
          pR_TypeOfJobOpportunityId:
            JobOpportunitiesDuringProject.pR_TypeOfJobOpportunityId,
          gender: JobOpportunitiesDuringProject.gender,
          natureOfOpportunity:
            JobOpportunitiesDuringProject.natureOfOpportunity,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      if (response.data.success === true) {
        const arrayValidate = response.data.result.map((ele, ind) => {
          return ele.code;
        });
        return arrayValidate; // Return the extracted data
      }
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetSpecificRowNoteJobOpportunitiesDuringProject = createAsyncThunk(
  "GetSpecificRowNoteJobOpportunitiesDuringProject/GetSpecificRowNoteJobOpportunitiesDuringProject",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesSubmitterData",
        parameters
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
return data;
      // return data.filter((item) => item.incrementNumber - 1 === 1);
      //   return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const JobOpportunitiesDuringProject = createSlice({
  name: "JobOpportunitiesDuringProject ",
  initialState: {
    OneJobOpportunitiesDuringProject: {},
    loadingOneJobOpportunitiesDuringProject: false,
    errorOneJobOpportunitiesDuringProject: null,
    //----------------------------------------------------------------
    AddJobOpportunitiesDuringProject: {},
    loadingAddJobOpportunitiesDuringProject: false,
    errorAddJobOpportunitiesDuringProject: null,
    //--------------------------------------------------------------------
    UpdateJobOpportunitiesDuringProject: {},
    loadingUpdateJobOpportunitiesDuringProject: false,
    errorUpdateJobOpportunitiesDuringProject: null,
    //-----------------------------------------------------------------------
    DeleteJobOpportunitiesDuringProject: {},
    loadingDeleteJobOpportunitiesDuringProject: false,
    errorDeleteJobOpportunitiesDuringProject: null,
    //---------------------------------------------------------------------------
    ListJobOpportunitiesDuringProject: {},
    loadingListJobOpportunitiesDuringProject: false,
    errorListJobOpportunitiesDuringProject: null,
    //------------------------------------------------------------------------------
    JobOpportunitiesDuringProjectValidate: [],
    loadingJobOpportunitiesDuringProjectValidate: false,
    errorJobOpportunitiesDuringProjectValidate: null,
    //----------------------------------------------------------------------------
    OneSpecificRowNoteJobOpportunitiesDuringProject: {},
    loadingOneSpecificRowNoteJobOpportunitiesDuringProject: false,
    errorOneSpecificRowNoteJobOpportunitiesDuringProject: null,
  },
  reducers: {
    restValidateJobOpportunitiesDuringProject: (state, action) => {
      state.JobOpportunitiesDuringProjectValidate = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneJobOpportunitiesDuringProjectData.pending,
        (state, action) => {
          state.loadingOneJobOpportunitiesDuringProject = true;
          state.OneJobOpportunitiesDuringProject = action.payload;
          state.errorOneJobOpportunitiesDuringProject = null;
        }
      )
      .addCase(
        GetOneJobOpportunitiesDuringProjectData.fulfilled,
        (state, action) => {
          state.loadingOneJobOpportunitiesDuringProject = false;
          state.OneJobOpportunitiesDuringProject = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOneJobOpportunitiesDuringProjectData.rejected,
        (state, action) => {
          state.loadingOneJobOpportunitiesDuringProject = false;
          state.errorOneJobOpportunitiesDuringProject = action.payload;
        }
      )

      .addCase(
        DeleteJobOpportunitiesDuringProjectData.pending,
        (state, action) => {
          state.loadingDeleteJobOpportunitiesDuringProject = true;
          state.DeleteJobOpportunitiesDuringProject = action.payload;
          state.errorDeleteJobOpportunitiesDuringProject = null;
        }
      )
      .addCase(
        DeleteJobOpportunitiesDuringProjectData.fulfilled,
        (state, action) => {
          state.loadingDeleteJobOpportunitiesDuringProject = false;
          state.DeleteJobOpportunitiesDuringProject = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        DeleteJobOpportunitiesDuringProjectData.rejected,
        (state, action) => {
          state.loadingDeleteJobOpportunitiesDuringProject = false;
          state.errorDeleteJobOpportunitiesDuringProject = action.payload;
        }
      )
      .addCase(
        GetListJobOpportunitiesDuringProjectData.pending,
        (state, action) => {
          state.loadingListJobOpportunitiesDuringProject = true;
          state.ListJobOpportunitiesDuringProject = action.payload;
          state.errorListJobOpportunitiesDuringProject = null;
        }
      )
      .addCase(
        GetListJobOpportunitiesDuringProjectData.fulfilled,
        (state, action) => {
          state.loadingListJobOpportunitiesDuringProject = false;
          state.ListJobOpportunitiesDuringProject = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetListJobOpportunitiesDuringProjectData.rejected,
        (state, action) => {
          state.loadingListJobOpportunitiesDuringProject = false;
          state.errorListJobOpportunitiesDuringProject = action.payload;
        }
      )
      .addCase(
        UpdateJobOpportunitiesDuringProjectData.pending,
        (state, action) => {
          state.loadingUpdateJobOpportunitiesDuringProject = true;
          state.UpdateJobOpportunitiesDuringProject = action.payload;
          state.errorUpdateJobOpportunitiesDuringProject = null;
        }
      )
      .addCase(
        UpdateJobOpportunitiesDuringProjectData.fulfilled,
        (state, action) => {
          state.loadingUpdateJobOpportunitiesDuringProject = false;
          state.UpdateJobOpportunitiesDuringProject = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        UpdateJobOpportunitiesDuringProjectData.rejected,
        (state, action) => {
          state.loadingUpdateJobOpportunitiesDuringProject = false;
          state.errorUpdateJobOpportunitiesDuringProject = action.payload;
        }
      )
      .addCase(
        ValidateJobOpportunitiesDuringProject.pending,
        (state, action) => {
          state.loadingJobOpportunitiesDuringProjectValidate = true;
          state.JobOpportunitiesDuringProjectValidate = action.payload;
          state.errorJobOpportunitiesDuringProjectValidate = null;
        }
      )
      .addCase(
        ValidateJobOpportunitiesDuringProject.fulfilled,
        (state, action) => {
          state.loadingJobOpportunitiesDuringProjectValidate = false;
          state.JobOpportunitiesDuringProjectValidate = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateJobOpportunitiesDuringProject.rejected,
        (state, action) => {
          state.loadingJobOpportunitiesDuringProjectValidate = false;
          state.errorJobOpportunitiesDuringProjectValidate = action.payload;
        }
      )
      .addCase(
        AddJobOpportunitiesDuringProjectData.pending,
        (state, action) => {
          state.loadingAddJobOpportunitiesDuringProject = true;
          state.AddJobOpportunitiesDuringProject = action.payload;
          state.errorAddJobOpportunitiesDuringProject = null;
        }
      )
      .addCase(
        AddJobOpportunitiesDuringProjectData.fulfilled,
        (state, action) => {
          state.loadingAddJobOpportunitiesDuringProject = false;
          state.AddJobOpportunitiesDuringProject = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        AddJobOpportunitiesDuringProjectData.rejected,
        (state, action) => {
          state.loadingAddJobOpportunitiesDuringProject = false;
          state.errorAddJobOpportunitiesDuringProject = action.payload;
        }
      )

      .addCase(
        GetSpecificRowNoteJobOpportunitiesDuringProject.pending,
        (state, action) => {
          state.loadingOneSpecificRowNoteJobOpportunitiesDuringProject = true;
          state.OneSpecificRowNoteJobOpportunitiesDuringProject =
            action.payload;
          state.errorOneSpecificRowNoteJobOpportunitiesDuringProject = null;
        }
      )
      .addCase(
        GetSpecificRowNoteJobOpportunitiesDuringProject.fulfilled,
        (state, action) => {
          state.loadingOneSpecificRowNoteJobOpportunitiesDuringProject = false;
          state.OneSpecificRowNoteJobOpportunitiesDuringProject =
            action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetSpecificRowNoteJobOpportunitiesDuringProject.rejected,
        (state, action) => {
          state.loadingOneSpecificRowNoteJobOpportunitiesDuringProject = false;
          state.errorOneSpecificRowNoteJobOpportunitiesDuringProject =
            action.payload;
        }
      );
  },
});
export const { restValidateJobOpportunitiesDuringProject } =
  JobOpportunitiesDuringProject.actions;
export default JobOpportunitiesDuringProject.reducer;
